import React, {Component, PropTypes} from 'react';
import { Record } from 'immutable';
import { toMoneyFormat } from '../../../tools/number';
import './InfoBlockParameters.scss';


class InfoBlockParameters extends Component {

    static propTypes = {
        parameters: PropTypes.objectOf(Record),
    };

    static defaultProps = {
        parameters: {},
    };

    renderParams = () => {
        const { parameters } = this.props;
        let resultParams = [];
        
        Object.keys(parameters).forEach((param, index) => {
            if (parameters[param].get('name') === 'loaders') {
                return;
            }

            // общее сравнение для всех параметров, для которых
            // нужно отображать только название параметра
            if (parameters[param].get('type') === 'checkbox') {
                if (parameters[param].get('value')) {
                    resultParams.push(
                        <p key={`${parameters[param].get('name')}-${index}-1`}>{parameters[param].get('title')}: да</p>
                    );
                } else {
                    switch (parameters[param].get('name')) {
                        case 'load_loaders':
                        case 'unload_loaders':
                        case 'packing_services':
                        case 'dismantling_assembling_furniture':
                            resultParams.push(
                                <p key={`${parameters[param].get('name')}-${index}-1`}>{parameters[param].get('title')}: нет</p>
                            );
                            break
                    }
                }
            }
            
            // общее сравнение для всех параметров, для которых
            // нужно отображать и название параметра, и список параметров
            if (parameters[param].get('type') === 'list') {
                if (parameters[param].get('value') && parameters[param].get('value').length === 0) {
                    return;
                }
    
                if (parameters.loaders && !parameters.loaders.get('value') &&
                    (parameters[param].get('name') === 'load_elevator' || parameters[param].get('name') === 'unload_elevator')) {
                    return;
                }
                
                if (parameters.loaders && parameters.loaders.get('value') &&
                    parameters.load_loaders && !parameters.load_loaders.get('value') &&
                    parameters[param].get('name') === 'load_elevator') {
                    return;
                }
    
                if (parameters.loaders && parameters.loaders.get('value') &&
                    parameters.unload_loaders && !parameters.unload_loaders.get('value') &&
                    parameters[param].get('name') === 'unload_elevator') {
                    return;
                }

                if (!parameters[param].get('value')) {
                    return;
                }

                resultParams.push(
                    <p key={`${parameters[param].get('name')}-${index}-0`}>{parameters[param].get('title')}</p>
                );
                
                Object.keys(parameters[param].get('values')).forEach((value) => {
                    const paramName = parameters[param].get('name');

                    if (paramName === 'load_elevator'
                        || paramName === 'unload_elevator'
                        || paramName === 'load_loaders_count'
                        || paramName === 'unload_loaders_count') {
                        if (parameters[param].get('value') === Number(value)) {
                            resultParams.push(
                                <p
                                    key={`${parameters[param].get('name')}-${index}-${value}`}
                                    style={{ fontStyle: 'italic' }}
                                >
                                    - {parameters[param].get('values')[value].value}
                                </p>
                            );
                        }
                    } else if (parameters[param].get('value').includes(Number(value))
                        || parameters[param].get('value').includes(value)) {
                        resultParams.push(
                            <p
                                key={`${parameters[param].get('name')}-${index}-${value}`}
                                style={{ fontStyle: 'italic' }}
                            >
                                - {parameters[param].get('values')[value].value}
                            </p>
                        );
                    }
                });
            }

            // общее сравнение для всех параметров, для которых
            // нужно отображать и название параметра, и текст параметра
            if (parameters[param].get('type') === 'text' && parameters[param].get('value')) {
                resultParams.push(
                    <p key={`${parameters[param].get('name')}-${index}-1`}>{parameters[param].get('title')}</p>,
                    <p key={`${parameters[param].get('name')}-${index}-2`} style={{ fontStyle: 'italic' }}> - {parameters[param].get('value')}</p>
                );
            }

            // общее сравнение для всех параметров, для которых
            // нужно отображать и название параметра, и его числовое значение
            switch (parameters[param].get('name')) {
                case 'hold_stuff_time':
                    if (parameters[param].get('value')) {
                        resultParams.push(
                            <p key={`${parameters[param].get('name')}-${index}-2`}>{parameters[param].get('title')}</p>,
                            <p key={`${parameters[param].get('name')}-${index}-1`}
                               style={{fontStyle: 'italic'}}> - {parameters[param].get('value')} дней</p>
                        );
                    }
                    break;

                case 'load_floor':
                case 'unload_floor':
    
                    if (parameters.loaders.get('value') && !parameters.load_loaders.get('value') && parameters[param].get('name') === 'load_floor') {
                        break
                    }
    
                    if (parameters.loaders.get('value') && !parameters.unload_loaders.get('value') && parameters[param].get('name') === 'unload_floor') {
                        break
                    }
                    
                    if (parameters.loaders.get('value')) {
                        resultParams.push(
                            <p key={`${parameters[param].get('name')}-${index}-1`}>{parameters[param].get('title')}</p>,
                            <p key={`${parameters[param].get('name')}-${index}-2`}
                               style={{fontStyle: 'italic'}}> - {parameters[param].get('value')} этаж</p>
                        );
                    }
                    break;

                case 'escort':
                    if (parameters[param].get('value')) {
                        resultParams.push(
                            <p key={`${parameters[param].get('name')}-${index}-1`}>{parameters[param].get('title')}</p>,
                            <p key={`${parameters[param].get('name')}-${index}-2`}
                               style={{fontStyle: 'italic'}}> - {parameters[param].get('value')} человек</p>
                        );
                    }
                    break;

                case 'desired_budget':
                    if (parameters[param].get('value')) {
                        resultParams.push(
                            <p key={`${parameters[param].get('name')}-${index}-1`}>{parameters[param].get('title')}</p>,
                            <p key={`${parameters[param].get('name')}-${index}-2`}
                               style={{fontStyle: 'italic'}}> - {toMoneyFormat(parameters[param].get('value'))}₽</p>
                        );
                    }
                    break;

                default:
                    break;
            }
        });
        
        if (resultParams.length === 0) {
            return (
                <p>Нет доп. услуг</p>
            )
        }

        return resultParams;
    }

    render() {
        return (
            <div className="InfoBlockParameters">
                {this.renderParams()}
            </div>
        )
    }
}


export default InfoBlockParameters;



// WEBPACK FOOTER //
// ./client/components/InfoBlockParameters/InfoBlockParameters.js